<template lang="pug">
    div.displayArea.grey.lighten-2(
        :style="getStyles.displayArea"
        ref="container"
        )
        //v-list.SalesCart(style="")
        v-divider
        CartHeaders
        v-divider
        template(v-for="(item, idx) in items" )
            ItemStrip.white(
                :ref="`itm${idx}`"
                :value="item"
                @input="itemChangeHandler(idx, $event)"
                :actions="getActions"
                @action="handleAction($event, idx)"
                enableActionsSlot
                :key="item.id"
                :vuexBindings="vuexBindings"
                :class="{'active-strip': idx === activeIndex}"
                style="border: 2px solid;"
                @click="activeIndex = idx"
                @blur="handleStripBlur()"
                @price:change="handlePriceChange($event)"
                :isCallCenter="isCallCenter"
            )
            v-divider
        barcode-scanner-handler(
            v-if="!disableScanner"
            @codescanned="scannerHandler($event)"
            @keydown="controlCart($event)"
            @scanner:blur="$emit('scanner:blur')"
            )
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import BarcodeScannerHandler from '@/components/BarcodeScannerHandler/BarcodeScannerHandler'
import ItemStrip from '@/components/ItemStrip/ItemStrip'
import DefaultActions from './DefaultActions.js'
import CartHeaders from './subcomponents/CartHeaders'
import { setTimeout } from 'timers'
import * as ProductService from '@/services/API/ProductService'

export default {
    props: {
        customActions: {
            type: Array,
            default: () => [],
        },
        cartHeight: {
            type: String,
            default: '100%',
        },
    },
    data: function() {
        return {
            vuexBindings: {
                module: 'CartModule',
                state: 'items',
                action: 'setCartItems',
            },
            focusedElement: {},
            disableScanner: false,
            activeIndex: 0,
        }
    },
    computed: {
        getStyles: function() {
            return {
                displayArea: {
                    height: this.cartHeight,
                },
            }
        },
        getActions() {
            let actions = this.customActions
            if (this.customActions.length == 0) actions = this.defaultActions
            return actions
        },
        ...mapState('CartModule', {
            items: 'items',
        }),
        ...mapState('TransactionModule', {
            waitingSupervisorAuth: 'waitingSupervisorAuth',
        }),
        ...mapGetters('TransactionModule', {
            activeSearchModals: 'activeSearchModals',
        }),
        ...mapGetters('AuthModule', {
            isGroundSeller: 'isGroundSeller',
            isCallCenter: 'isCallCenter',
        }),
    },
    methods: {
        deleteItem: function(items, idx) {
            items = items.splice(idx, 1)
        },
        showItem: function(items, idx) {
            alert(items[idx].nombre)
        },
        ...mapActions('CartModule', {
            setCartItems: 'setCartItems',
            addItemToCart: 'addItemToCart',
        }),
        itemChangeHandler: function(idx, value) {
            this.$set(this.items, idx, value)
        },
        scannerHandler: async function(code) {
            const item = await ProductService.findByKey({
                field: 'upc_code',
                value: code,
            })
            if (item) this.addItemToCart(item)
        },
        handleAction: function(event, idx) {
            event(this.items, idx)
            this.setCartItems(JSON.parse(JSON.stringify(this.items)))
        },
        controlCart(e) {
            let prevent = event => {
                event.preventDefault()
                event.stopPropagation()
            }
            let itm = this.items[this.activeIndex]
            switch (e.keyCode) {
                // Arrow UP
                case 38:
                    prevent(e)
                    if (this.activeIndex > 0) this.activeIndex--
                    this.autoScroll()
                    break
                // Arrow Down
                case 40:
                    prevent(e)
                    if (this.activeIndex < this.items.length - 1)
                        this.activeIndex++
                    this.autoScroll()
                    break
                // Key +
                case 107:
                    prevent(e)
                    if (itm.quantity < itm.stock) itm.quantity++
                    break
                // Key -
                case 109:
                    prevent(e)
                    if (itm.quantity > 1) itm.quantity--
                    break
                // Key Supr
                case 46:
                    prevent(e)
                    let items = [...this.items]
                    items.splice(this.activeIndex, 1)
                    this.setCartItems([...items])
                    if (this.items.length === 0) {
                        this.activeIndex = 0
                    } else if (this.activeIndex >= this.items.length) {
                        this.activeIndex = this.items.length - 1
                    }
                    break
                // Key C
                case 67:
                    prevent(e)
                    this.$refs['itm' + this.activeIndex][0].focusCounter()
                    break
                // Key R
                case 82:
                    prevent(e)
                    this.$refs['itm' + this.activeIndex][0].focusPriceReplace()
                    break
                // Key P
                case 80:
                    prevent(e)
                    this.$refs['itm' + this.activeIndex][0].activateDiscount()
                    break
                // Key P
                case 76:
                    prevent(e)
                    this.$refs['itm' + this.activeIndex][0].activateDiscount(
                        '$'
                    )
                    break
                default:
                    break
            }
        },
        handleStripBlur() {
            document.getElementById('barcode-scanner-input').focus()
        },
        autoScroll() {
            const containerHeight = this.$refs.container.offsetHeight
            const containerOffsetTop = this.$refs.container.scrollTop
            const activeOffset = this.$refs[`itm${this.activeIndex}`][0].$el
                .offsetTop
            const containerOffset = containerOffsetTop + containerHeight
            if (activeOffset >= containerOffset) {
                this.$refs.container.scrollTop += 53
            } else {
                this.$refs.container.scrollTop -= 52
            }
        },
        handlePriceChange(e) {
            this.setCartItems([...this.items])
        },
    },
    watch: {
        waitingSupervisorAuth: function() {
            this.disableScanner = this.waitingSupervisorAuth
        },
        activeSearchModals: function(val) {
            if (!val) document.getElementById('barcode-scanner-input').focus()
        },
    },
    components: {
        ItemStrip,
        CartHeaders,
        'barcode-scanner-handler': BarcodeScannerHandler,
    },
    mixins: [DefaultActions],
    created() {
        if (this.isGroundSeller) this.$router.push('/mobile')
    },
}
</script>

<style lang="scss" scoped>
.ListArea {
    background: rgba(0, 0, 0, 0);
}
.displayArea {
    padding: 0;
    padding: 0px;
    border: 2px solid #cccccc !important;
    overflow-y: auto;
}
.SalesCart {
    position: relative;
    padding: 0 !important;
}
#barcode-scanner-input {
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    margin-left: -1000px;
}
.active-strip {
    // border: 2px solid blue;
    border-color: blue !important;
}
</style>
